export default "__VITE_ASSET__CuMee7In__"